/**
 * ZALT Cart Drawer
 * AJAX cart using Shopify Cart API
 */
(function () {
  'use strict';

  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-overlay]');
  var closeBtn = document.querySelector('[data-cart-drawer-close]');
  var emptyEl = document.querySelector('[data-cart-empty]');
  var itemsEl = document.querySelector('[data-cart-items]');
  var footerEl = document.querySelector('[data-cart-footer]');
  var countEls = document.querySelectorAll('[data-cart-count]');
  var openBtns = document.querySelectorAll('[data-cart-drawer-open]');
  var minCansMsgEl = document.querySelector('[data-min-cans-msg]');
  var checkoutBtnEl = document.querySelector('[data-cart-checkout]');
  var minCartCans = drawer
    ? parseInt(drawer.getAttribute('data-min-cart-cans'), 10) || 4
    : 4;

  var cart = null;

  /* ---- Upsells ---- */
  var upsellsEl = document.querySelector('[data-cart-upsells]');
  var upsellsListEl = document.querySelector('[data-cart-upsells-list]');
  var upsellsTitleEl = document.querySelector('[data-cart-upsells-title]');
  var subUpgradeEl = document.querySelector('[data-cart-sub-upgrade]');
  var subSavingsEl = document.querySelector('[data-cart-sub-savings]');
  var upsellsConfigEl = document.querySelector('[data-cart-upsells-config]');
  var upsellsConfig = { products: [], variantSubMap: [], filterInCart: true, subscribeBanner: true };
  if (upsellsConfigEl) {
    try { upsellsConfig = Object.assign(upsellsConfig, JSON.parse(upsellsConfigEl.textContent)); } catch (e) {}
  }
  var subPlanByVariant = {};
  (upsellsConfig.variantSubMap || []).forEach(function (m) { subPlanByVariant[m.variantId] = m; });

  /* ---- Single-can top-up ----
     Shown when total cans < min_cart_cans. Lets the customer add 1 can at a
     time so they can hit the floor without buying another full pack. */
  var topupEl = document.querySelector('[data-cart-topup]');
  var topupListEl = document.querySelector('[data-cart-topup-list]');
  var topupConfigEl = document.querySelector('[data-cart-topup-config]');
  var topupProducts = [];
  if (topupConfigEl) {
    try { topupProducts = JSON.parse(topupConfigEl.textContent) || []; } catch (e) {}
  }
  topupProducts = topupProducts.filter(function (p) { return p && p.variantId && p.available; });

  /* ---- Open / Close ---- */

  function open() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    fetchCart();

    if (cart && cart.items.length > 0) {
      trackEvent('view_cart', {
        ecommerce: {
          currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'USD',
          value: cart.total_price / 100,
          items: cartToAnalyticsItems(cart.items)
        }
      });
    }
  }

  function close() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  openBtns.forEach(function (btn) { btn.addEventListener('click', open); });
  if (closeBtn) closeBtn.addEventListener('click', close);
  if (overlay) overlay.addEventListener('click', close);

  /* ---- Shopify Cart API ---- */

  function fetchCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        cart = data;
        render();
      });
  }

  function addItem(variantId, quantity, sellingPlanId, properties) {
    var body = {
      id: variantId,
      quantity: quantity || 1
    };
    if (sellingPlanId) body.selling_plan = sellingPlanId;
    if (properties && Object.keys(properties).length) body.properties = properties;

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (item) {
        trackEvent('add_to_cart', {
          ecommerce: {
            currency: item.price > 0 ? 'USD' : 'USD',
            value: item.final_line_price / 100,
            items: [{
              item_id: item.product_id,
              item_name: item.product_title,
              item_variant: item.variant_title,
              price: item.final_price / 100,
              quantity: item.quantity
            }]
          }
        });
        fetchCart();
        open();
        return item;
      });
  }

  function changeItem(lineKey, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        cart = data;
        render();
        return data;
      });
  }

  function removeItem(lineKey) {
    var item = cart ? cart.items.find(function(i) { return i.key === lineKey; }) : null;
    if (item) {
      trackEvent('remove_from_cart', {
        ecommerce: {
          currency: 'USD',
          value: item.final_line_price / 100,
          items: [{
            item_id: item.product_id,
            item_name: item.product_title,
            item_variant: item.variant_title,
            price: item.final_price / 100,
            quantity: item.quantity
          }]
        }
      });
    }
    return changeItem(lineKey, 0);
  }

  /* ---- Rendering ---- */

  /* ---- Cans counting ----
     Priority:
       1. Line item property `_cans` (set by configurator / product-form).
       2. Title regex: "(\d+)[\s-]?pack" matches "5-Pack", "5 pack", "4-pack", etc.
       3. Default 1.
  */
  function cansForItem(item) {
    if (item.properties && item.properties._cans) {
      var fromProp = parseInt(item.properties._cans, 10);
      if (fromProp > 0) return fromProp;
    }
    var haystack = ((item.product_title || '') + ' ' + (item.variant_title || '')).toLowerCase();
    var m = haystack.match(/(\d+)\s*[-\s]?\s*pack/);
    if (m) {
      var n = parseInt(m[1], 10);
      if (n > 0) return n;
    }
    return 1;
  }

  function totalCans(c) {
    if (!c || !c.items) return 0;
    var sum = 0;
    c.items.forEach(function (item) {
      sum += cansForItem(item) * item.quantity;
    });
    return sum;
  }

  /* ---- Upsells render + handlers ---- */

  function productIdsInCart() {
    var ids = {};
    if (!cart || !cart.items) return ids;
    cart.items.forEach(function (item) { ids[item.product_id] = true; });
    return ids;
  }

  function oneTimeItems() {
    if (!cart || !cart.items) return [];
    return cart.items.filter(function (item) {
      return !item.selling_plan_allocation;
    });
  }

  function subUpgradeSavingsCents() {
    var ot = oneTimeItems();
    var savings = 0;
    ot.forEach(function (item) {
      var map = subPlanByVariant[item.variant_id];
      if (!map) return;
      // Per-unit one-time price minus per-unit sub price, times quantity.
      var unitOt = item.final_price; // already per-unit cents
      var unitSub = map.subPrice;
      if (unitSub != null && unitSub < unitOt) {
        savings += (unitOt - unitSub) * item.quantity;
      }
    });
    return savings;
  }

  function renderUpsells() {
    if (!upsellsEl) return;

    var anyVisible = false;

    // Subscribe-upgrade banner
    if (subUpgradeEl) {
      var ot = oneTimeItems();
      var convertible = ot.filter(function (item) { return subPlanByVariant[item.variant_id]; });
      if (upsellsConfig.subscribeBanner && convertible.length > 0) {
        subUpgradeEl.hidden = false;
        anyVisible = true;
        var savings = subUpgradeSavingsCents();
        if (subSavingsEl) {
          subSavingsEl.textContent = savings > 0
            ? 'Save ' + formatMoney(savings) + ' on this order'
            : '';
        }
      } else {
        subUpgradeEl.hidden = true;
      }
    }

    // Product upsell rows
    if (upsellsListEl) {
      var inCart = productIdsInCart();
      var products = (upsellsConfig.products || []).filter(function (p) {
        if (!p.available) return false;
        if (upsellsConfig.filterInCart && inCart[p.id]) return false;
        return true;
      });

      if (products.length > 0) {
        if (upsellsTitleEl) upsellsTitleEl.style.display = '';
        anyVisible = true;
        var html = products.map(function (p) {
          return (
            '<div class="cart-upsell" data-upsell-product="' + p.id + '">' +
              '<span class="cart-upsell__image">' +
                (p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '') +
              '</span>' +
              '<span class="cart-upsell__info">' +
                '<span class="cart-upsell__title">' + escapeHtml(p.title) + '</span>' +
                '<span class="cart-upsell__price">' + formatMoney(p.price) + '</span>' +
              '</span>' +
              '<button type="button" class="cart-upsell__add" data-upsell-add="' + p.variantId + '">+ Add</button>' +
            '</div>'
          );
        }).join('');
        upsellsListEl.innerHTML = html;
      } else {
        upsellsListEl.innerHTML = '';
        if (upsellsTitleEl) upsellsTitleEl.style.display = 'none';
      }
    }

    upsellsEl.hidden = !anyVisible;
  }

  if (upsellsListEl) {
    upsellsListEl.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-upsell-add]');
      if (!btn) return;
      var variantId = parseInt(btn.getAttribute('data-upsell-add'), 10);
      if (!variantId || btn.disabled) return;
      btn.disabled = true;
      btn.setAttribute('data-state', 'adding');
      btn.textContent = 'Adding…';
      addItem(variantId, 1).then(function () {
        btn.setAttribute('data-state', 'added');
        btn.textContent = 'Added';
      }).catch(function () {
        btn.disabled = false;
        btn.removeAttribute('data-state');
        btn.textContent = '+ Add';
      });
    });
  }

  if (subUpgradeEl) {
    subUpgradeEl.addEventListener('click', function () {
      var ot = oneTimeItems();
      if (ot.length === 0) return;
      subUpgradeEl.disabled = true;
      // Cart API doesn't let us set selling_plan via /cart/change.js — we have
      // to remove + re-add each line. Sequence them so the cart doesn't drift.
      var chain = Promise.resolve();
      ot.forEach(function (item) {
        var map = subPlanByVariant[item.variant_id];
        if (!map || !map.sellingPlanId) return;
        chain = chain.then(function () {
          return changeItem(item.key, 0).then(function () {
            return addItem(item.variant_id, item.quantity, map.sellingPlanId);
          });
        });
      });
      chain.finally(function () {
        subUpgradeEl.disabled = false;
        fetchCart();
      });
    });
  }

  function render() {
    if (!cart) return;

    // Broadcast cart state so the product configurator (and any other surface
    // that mirrors cart contents) can stay in sync. Fires on every cart fetch
    // and mutation since render is the single funnel point.
    document.dispatchEvent(new CustomEvent('zalt:cart-updated', { detail: cart }));

    updateCount(cart.item_count);
    updateMinCansGate();
    renderTopup();

    if (cart.items.length === 0) {
      emptyEl.style.display = '';
      itemsEl.style.display = 'none';
      footerEl.style.display = 'none';
      if (upsellsEl) upsellsEl.hidden = true;
      if (topupEl) topupEl.hidden = true;
      return;
    }

    emptyEl.style.display = 'none';
    itemsEl.style.display = '';
    footerEl.style.display = '';
    renderUpsells();

    var html = '';
    cart.items.forEach(function (item) {
      var variantTitle = item.variant_title || '';
      var sellingPlanName = item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.name : '';

      html += '<div class="cart-item" data-line-key="' + item.key + '">';
      html += '  <div class="cart-item__image">';
      html += '    <img src="' + getSizedImageUrl(item.image, '128x128') + '" alt="' + escapeHtml(item.product_title) + '" width="64" height="64">';
      html += '  </div>';
      var perLineCans = cansForItem(item);
      var totalLineCans = perLineCans * item.quantity;
      html += '  <div class="cart-item__info">';
      html += '    <a href="' + item.url + '" class="cart-item__title">' + escapeHtml(item.product_title) + '</a>';
      if (variantTitle) {
        html += '    <span class="cart-item__variant">' + escapeHtml(variantTitle) + '</span>';
      }
      if (sellingPlanName) {
        html += '    <span class="cart-item__selling-plan">' + escapeHtml(sellingPlanName) + '</span>';
      }
      if (perLineCans > 1) {
        html += '    <span class="cart-item__cans">' + totalLineCans + ' cans total</span>';
      }
      html += '  </div>';
      html += '  <div class="cart-item__actions">';
      html += '    <span class="cart-item__price">' + formatMoney(item.final_line_price) + '</span>';
      html += '    <div style="display:flex;align-items:center;gap:0.5rem;">';
      html += '      <div class="cart-item__quantity">';
      html += '        <button class="cart-item__qty-btn" data-qty-change="' + item.key + '" data-qty-dir="minus" aria-label="Decrease quantity">&minus;</button>';
      html += '        <span class="cart-item__qty-value">' + item.quantity + '</span>';
      html += '        <button class="cart-item__qty-btn" data-qty-change="' + item.key + '" data-qty-dir="plus" aria-label="Increase quantity">+</button>';
      html += '      </div>';
      html += '      <button class="cart-item__remove" data-remove-item="' + item.key + '" aria-label="Remove item">';
      html += '        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path stroke-linecap="round" stroke-linejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" /></svg>';
      html += '      </button>';
      html += '    </div>';
      html += '  </div>';
      html += '</div>';
    });

    itemsEl.innerHTML = html;
    bindItemEvents();
  }

  function bindItemEvents() {
    itemsEl.querySelectorAll('[data-qty-change]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-qty-change');
        var dir = btn.getAttribute('data-qty-dir');
        var item = cart.items.find(function (i) { return i.key === key; });
        if (!item) return;
        var newQty = dir === 'plus' ? item.quantity + 1 : item.quantity - 1;
        if (newQty < 1) {
          removeItem(key);
        } else {
          changeItem(key, newQty);
        }
      });
    });

    itemsEl.querySelectorAll('[data-remove-item]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        removeItem(btn.getAttribute('data-remove-item'));
      });
    });
  }

  /* ---- Cart count badge ---- */

  function updateCount(count) {
    countEls.forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  /* ---- Minimum cans gate ---- */

  function updateMinCansGate() {
    if (!checkoutBtnEl) return;
    var cans = totalCans(cart);
    var needed = minCartCans - cans;
    if (needed > 0) {
      checkoutBtnEl.classList.add('is-disabled');
      checkoutBtnEl.setAttribute('aria-disabled', 'true');
      if (minCansMsgEl) {
        minCansMsgEl.textContent = 'Add ' + needed + ' more ' + (needed === 1 ? 'can' : 'cans') + ' to checkout';
        minCansMsgEl.hidden = false;
      }
    } else {
      checkoutBtnEl.classList.remove('is-disabled');
      checkoutBtnEl.removeAttribute('aria-disabled');
      if (minCansMsgEl) {
        minCansMsgEl.hidden = true;
      }
    }
  }

  if (checkoutBtnEl) {
    checkoutBtnEl.addEventListener('click', function (e) {
      if (checkoutBtnEl.classList.contains('is-disabled')) {
        e.preventDefault();
      }
    });
  }

  /* ---- Top-up render ----
     Surfaces single-can quick-add buttons when total cans < min_cart_cans.
     Picks a matching subscription plan if the cart already has any sub
     items (Skio order grouping happens server-side via shared sub plan). */
  function cartHasSubscription() {
    if (!cart || !cart.items) return false;
    return cart.items.some(function (i) { return i.selling_plan_allocation; });
  }

  function renderTopup() {
    if (!topupEl || !topupListEl || !topupProducts.length) return;
    var cans = totalCans(cart);
    if (cans <= 0 || cans >= minCartCans) {
      topupEl.hidden = true;
      return;
    }
    var hasSub = cartHasSubscription();
    var html = topupProducts.map(function (p) {
      var label = (p.title || '').replace(/\s+/g, ' ').trim();
      return (
        '<button type="button" class="cart-topup-btn" data-cart-topup-add="' + p.variantId + '" aria-label="Add 1 ' + escapeHtml(label) + ' can">' +
          '<span class="cart-topup-btn__img">' +
            (p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '') +
          '</span>' +
          '<span class="cart-topup-btn__label">' + escapeHtml(label) + '</span>' +
          '<span class="cart-topup-btn__plus">+ ' + (hasSub && p.sellingPlanId ? 'Sub' : '1 can') + '</span>' +
        '</button>'
      );
    }).join('');
    topupListEl.innerHTML = html;
    topupEl.hidden = false;
  }

  if (topupListEl) {
    topupListEl.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cart-topup-add]');
      if (!btn || btn.disabled) return;
      var variantId = parseInt(btn.getAttribute('data-cart-topup-add'), 10);
      if (!variantId) return;
      var product = topupProducts.find(function (p) { return p.variantId === variantId; });
      if (!product) return;
      btn.disabled = true;
      var sellingPlanId = cartHasSubscription() ? product.sellingPlanId : null;
      addItem(variantId, 1, sellingPlanId, { _cans: '1' })
        .catch(function () { /* keep button disabled briefly; refresh resets it */ })
        .finally(function () { /* re-render replaces the buttons */ });
    });
  }

  /* ---- Helpers ---- */

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  function getSizedImageUrl(url, size) {
    if (!url) return '';
    if (url.indexOf('_' + size) !== -1) return url;
    var match = url.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i);
    if (match) {
      var prefix = url.split(match[0]);
      return prefix[0] + '_' + size + match[0];
    }
    return url;
  }

  function trackEvent(name, data) {
    if (window.dataLayer) {
      window.dataLayer.push(Object.assign({ event: name }, data));
    }
  }

  function cartToAnalyticsItems(items) {
    return items.map(function (item) {
      return {
        item_id: item.product_id,
        item_name: item.product_title,
        item_variant: item.variant_title,
        price: item.final_price / 100,
        quantity: item.quantity
      };
    });
  }

  /* ---- Checkout tracking ---- */

  var checkoutBtn = document.querySelector('[data-cart-checkout]');
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function () {
      if (checkoutBtn.classList.contains('is-disabled')) return;
      if (cart && cart.items.length > 0) {
        trackEvent('begin_checkout', {
          ecommerce: {
            currency: 'USD',
            value: cart.total_price / 100,
            items: cartToAnalyticsItems(cart.items)
          }
        });
      }
    });
  }

  /* ---- Initial load ---- */
  fetchCart();

  /* ---- Refresh on BFCache restore / tab focus ----
     When the user clicks "Buy Now" → checkout → browser back, the PDP can be
     restored from BFCache without re-running scripts. Without this, the cart
     badge stays stale until something else (e.g. opening the drawer) triggers
     a re-fetch. */
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) fetchCart();
  });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') fetchCart();
  });

  /* ---- Public API ---- */
  window.ZaltCart = {
    open: open,
    close: close,
    addItem: addItem,
    changeItem: changeItem,
    removeItem: removeItem,
    refresh: fetchCart
  };
})();
